import PlusSign from "../PlusSign/PlusSign";
import "./BlockDialog.scss";
import Dialog from '../../../dialogs/Dialog';

import { deepCopy, editWidth } from "../../utils/onDragUtils";
import { useState, useEffect } from "react";

import SectionDialog from "./SectionDialog";
import LineDialog from "./LineDialog";
import TitleDialog from "./TitleDialog";
import CustomComponentDialog from "./CustomComponentDialog";

const FIELD = 0
const COLUMN = 1
const ROW = 2

const UiBlocks = (uiBlocks, handleAdd) => {
    return (
        <div className="ui-block-dialog-container">
            <div className="ui-block-components-container">
                {uiBlocks.map((block, blockIndex) => {
                    return (
                        <div key={blockIndex} onClick={() => handleAdd(blockIndex)} className="ui-block-dialog">{block.title} <PlusSign /></div>
                    )
                })}
            </div>
        </div>
    )
}

const Components = (fieldToMake, setOpenDialogs, setIsDefaultOpen) => {
    return (
        <div className="ui-block-dialog-container">
            <div className="ui-block-components-container">
                {fieldToMake === ROW && <div onClick={() => { setOpenDialogs.section(true); setIsDefaultOpen(false); }} className="ui-block-dialog full">{"Sekcia"} <PlusSign /></div>}
                {fieldToMake === ROW && <div onClick={() => { setOpenDialogs.line(true); setIsDefaultOpen(false); }} className="ui-block-dialog full">{"Čiara"} <PlusSign /></div>}
                <div onClick={() => { setOpenDialogs.title(true); setIsDefaultOpen(false); }} className="ui-block-dialog full">{"Nadpis"} <PlusSign /></div>
                <div onClick={() => { setOpenDialogs.custom(true); setIsDefaultOpen(false); }} className="ui-block-dialog full">{"Vlastný komponent"} <PlusSign /></div>
            </div>
        </div>
    )
}


export default function BlockDialog({ setOpen, isOpen, uiBlocks, setBuildArea, buildArea, setUiBlocks, rowIndex, columnIndex, count, fieldToMake }) {
    const [isComponents, setIsComponents] = useState(true)
    const [isUiBlocks, setIsUiBlocks] = useState(false)

    const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
    const [isAddLineOpen, setIsAddLineOpen] = useState(false);
    const [isAddTitleOpen, setIsAddTitleOpen] = useState(false);
    const [isAddCustomOpen, setIsAddCustomOpen] = useState(false);

    const [isDefaultOpen, setIsDefaultOpen] = useState(true);
    
    useEffect(() => {
        const el = document.querySelector('.AkcUiDesigner');
        if (!el)
            return;
        const z_index = parseInt(window.getComputedStyle(el).zIndex) + 10;
        document.documentElement.style.setProperty('--dnd-clone-z', z_index);
    }, [isDefaultOpen, isAddCustomOpen, isAddLineOpen, isAddTitleOpen, isAddCustomOpen]);

    const handleAdd = (index) => {
        var buildAreaCopy = deepCopy(buildArea);
        switch (fieldToMake) {
            case FIELD:
                buildAreaCopy[rowIndex].data[columnIndex].data.push(uiBlocks[index])
                break;
            case COLUMN:
                const column = { type: "column", data: [uiBlocks[index]] }
                buildAreaCopy[rowIndex].data = count === 0 ? [column, ...buildAreaCopy[rowIndex].data] : [...buildAreaCopy[rowIndex].data, column];
                if (buildAreaCopy[rowIndex].data.length === 3)
                    buildAreaCopy[rowIndex] = editWidth(buildAreaCopy[rowIndex]);

                break;
            case ROW: {
                const row = { type: "row", data: [{ type: "column", data: [uiBlocks[index]] }] };
                buildAreaCopy.splice(count, 0, row);
                break;
            }
            default:
                break;
        }

        setBuildArea(buildAreaCopy);
        setUiBlocks(uiBlocks.filter((_, blockIndex) => index !== blockIndex));
        setOpen(false);
    }

    return (
        <>
            {isAddSectionOpen && <SectionDialog setOpen={setIsAddSectionOpen} isOpen={isAddSectionOpen} setBuildArea={setBuildArea} count={count} parentSetOpen={setOpen} />}
            {isAddLineOpen && <LineDialog setOpen={setIsAddLineOpen} setBuildArea={setBuildArea} isOpen={isAddLineOpen} count={count} parentSetOpen={setOpen} />}
            {isAddTitleOpen && <TitleDialog setOpen={setIsAddTitleOpen} setBuildArea={setBuildArea} isOpen={isAddTitleOpen} count={count} parentSetOpen={setOpen} fieldToMake={fieldToMake} rowIndex={rowIndex} columnIndex={columnIndex} />}
            {isAddCustomOpen && <CustomComponentDialog setOpen={setIsAddCustomOpen} isOpen={isAddCustomOpen} setBuildArea={setBuildArea} count={count} parentSetOpen={setOpen} fieldToMake={fieldToMake} rowIndex={rowIndex} columnIndex={columnIndex} />}
           
            {
                isDefaultOpen && 
            <Dialog
                title={"Komponenty"}
                isOpen={isOpen}
                onClose={() => setOpen(false)}
                className={"AkcUiDesigner"}
                level={1}
                width={window.innerWidth / 2}
                hideButtons={true}
                >
                <>
                <div className="tab-switcher">
                    <h3 className={isComponents ? "components-title active" : "components-title"} onClick={() => { setIsUiBlocks(false); setIsComponents(true) }}>Design komponenty</h3>
                    <h3 className={isUiBlocks ? "components-title active" : "components-title"} onClick={() => { setIsUiBlocks(true); setIsComponents(false) }}>Položky formulára</h3>
                </div>
                {isComponents && Components(fieldToMake, { section: setIsAddSectionOpen, line: setIsAddLineOpen, title: setIsAddTitleOpen, custom: setIsAddCustomOpen }, setIsDefaultOpen)}
                {isUiBlocks && UiBlocks(uiBlocks, handleAdd)}
                </>
            </Dialog>
            }
        </>
    )
}